import React from "react";
import * as S from "./styles";

var Pricing = function Pricing(_ref) {
  var e = _ref.price,
      t = _ref.promoPrice,
      r = _ref.promoText;
  return React.createElement(React.Fragment, null, React.createElement(S.PriceContainer, {
    "data-testid": "pricing-container"
  }, React.createElement(S.ProductPrice, {
    hasPromoPrice: !!t
  }, e), t && React.createElement(S.PromoPrice, {
    "data-testid": "pricing-promo"
  }, t)), r && React.createElement(S.PromoText, {
    "data-testid": "pricing-promo-text"
  }, r));
};

export default Pricing;